<app-layout-crud-index
  [titulo]="title"
  [length]="length"
  [dataSource]="dataSource"
  [filterFields]="filterFields"
  [filterInitialValues]="filterFormValues"
  [configColumns]="configColumns"
  [displayedColumns]="displayedColumns"
  (onChangePage)="changePage($event)"
  (onFilter)="filter($event)"
  (onSubmitAdvancedFilter)="submitAdvancedFilter($event)"
  (onResetFilter)="resetFilter()"
  (onOpenShow)="_openShow($event)"
  (onOpenNew)="_openNew($event)"
  (onOpenEdit)="_openEdit($event)"
  (onOpenDelete)="openDelete($event)"
  (settings)="openSettings($event)"
  (active)="active($event)"
  (inactive)="inactive($event)">
  <table-responsive
    table
    [length]="length"
    [insideTheMenu] = "['DashboardButton','PeopleLockButton','LockButton','ActiveButton']"
    [buttons]="partnerButtons"
    (buttonAction)="handlePartnerAction($event)"
    (changePage)="changePage($event)"
    (filter)="filter($event)"
    [displayedColumns]="displayedColumns"
    [dataSource]="dataSource"
    [configColumns]="configColumns"
    [initialFilterValue]="params.filter"
    (openShow)="_openShow($event)"
    (openNew)="_openNew($event)"
    (openEdit)="_openEdit($event)"
    (openDelete)="openDelete($event)"
    [showLock]="true"
    [showPeopleLock]="true"
    [showKey]="true"
    [showActive]="true"
    [activeProperty]="'isActive'"
    (openContractsModal)="openContractsDialog($event)"
    [showDashboardButton]="true"
    [showContractsButton]="true"
    (dashboard)="navigateToCommissionsDashboard($event)"
    [lockProperty]="'isActive'"
    (lock)="lock($event)"
    (key)="key($event)"
    (unlock)="unlock($event)"
    [lockPeopleProperty]="'isWalletActive'"
    (lockPeople)="lockPeople($event)"
    (unlockPeople)="unlockPeople($event)"
    (onSelectionChange)="onSelectionChange($event)"
    [currentTab]="currentTab"
    [userType]="userType"
    [isEditableShow]="permissionService.is(permissionService.systemActionRoles.PARTNERS_EDIT_BUTTON_SHOW)"
    [isEditableEnabled]="permissionService.is(permissionService.systemActionRoles.PARTNERS_EDIT_BUTTON_ENABLED)"
    [isDeletableShow]="permissionService.is(permissionService.systemActionRoles.PARTNERS_DELETE_BUTTON_SHOW)"
    [isDeletableEnabled]="permissionService.is(permissionService.systemActionRoles.PARTNERS_DELETE_BUTTON_ENABLED)"
    (active)="active($event)"
    (inactive)="inactive($event)">
  </table-responsive>
  <div footer>
    <div fxFlex fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4">
      <div fxFlex>
        <button
          [disabled]="!selection?.selected || selection?.selected?.length != 1"
          class="action-button"
          mat-raised-button
          (click)="generateAccess(selection?.selected[0])">
          GERAR ACESSO
        </button>
      </div>
      <div fxFlex>
        <button
          fxFlex
          class="action-button"
          mat-raised-button
          (click)="generateContract()"
          [disabled]="!selection?.selected || selection?.selected?.length !== 1">
          GERAR CONTRATO
        </button>
      </div>
      <div fxFlex>
        <button
          class="action-button"
          mat-raised-button
          (click)="navigateToCommissionsDashboard(selection?.selected?.length === 1 ? selection?.selected[0] : null)">
          DASHBOARD
        </button>
      </div>
      <div fxFlex>
        <button
          class="action-button"
          mat-raised-button
          (click)="navigateToCustomerAccess()">
          ACESSOS
        </button>
      </div>
      <div fxFlex>
        <button
          class="action-button"
          mat-raised-button
          [disabled]="!selection?.selected"
          (click)="generateReports()">
          Gerar Relatório
        </button>
      </div>
    </div>
  </div>
</app-layout-crud-index>
